import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import GroupedUsageTable from '../GroupedUsageTable.js';
import { sumEnabledVolume } from '../calculations/balanceCalculations.js';

/**
 * Étape 2 : débouchés — usages tolérant une eau non potable (chasses d'eau, lavage des sols,
 * arrosage extérieur), pré-cochés à partir de l'audit. Détermine le "besoin" en face du
 * gisement de l'étape précédente.
 */
const UsagesStep = ({ targets, setTargets, groups, currentStep, totalSteps, goPrevious, goNext, canAdvance }) => {
  const { building_id } = useParams();
  const total = useMemo(() => sumEnabledVolume(targets), [targets]);
  const hasAuditData = targets.some(it => it.fromAudit);

  return (
    <div className="apv2-step-card">
      <div className="apv2-step-header">
        <div className="apv2-step-header-text">
          <span className="apv2-step-eyebrow">Réutilisation des eaux grises</span>
          <h2 className="apv2-step-heading">Débouchés — usages valorisables</h2>
        </div>
        <span className="apv2-step-counter">{currentStep + 1} / {totalSteps}</span>
      </div>
      <div className="apv2-step-body">
        <div className="apv2-step-explanation">
          <span className="apv2-step-explanation-icon">💡</span>
          <p className="apv2-step-explanation-text">
            {hasAuditData
              ? "Chasses d'eau, lavage des sols et arrosage extérieur de l'audit sont pré-cochés — les usages tolérant une eau non potable. Dépliez une catégorie pour décocher des points précis ou ajouter un débouché manuel."
              : "Aucun usage compatible détecté dans l'audit de ce bâtiment — dépliez une catégorie ci-dessous pour ajouter vos débouchés manuellement."}
            {' '}<a href={`/client/${building_id}/usages`} target="_blank" rel="noopener noreferrer">Corriger dans l'audit ↗</a>
          </p>
        </div>

        <GroupedUsageTable items={targets} setItems={setTargets} groups={groups} />

        <div className="apv2-summary-cards">
          <div className="apv2-summary-card">
            <span className="apv2-summary-value">{total.toLocaleString('fr-FR', { maximumFractionDigits: 1 })} m³</span>
            <span className="apv2-summary-label">besoin en eau non potable / an</span>
          </div>
        </div>
      </div>
      <div className="apv2-step-footer">
        <button type="button" className="apv2-footer-btn-ghost" onClick={goPrevious} disabled={currentStep === 0}>
          ← Précédent
        </button>
        <button type="button" className="apv2-footer-btn-cta" onClick={goNext} disabled={!canAdvance}>
          Suivant →
        </button>
      </div>
    </div>
  );
};

export default UsagesStep;
